import { makeStyles } from '@policygenius/mortar';

const styles = makeStyles(() => ({
  list: {
    listStyle: 'initial',
    listStylePosition: 'inside',
  },
}));

export default styles;
